require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./stateful-widget-lifecycle.json") })
        }
      }, "path---stateful-widget-lifecycle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---stateful-widget-lifecycle!./.cache/json/stateful-widget-lifecycle.json
// module id = 413
// module chunks = 231608221292675